import React from 'react';
import styled from 'styled-components';
import { Progress, Icon } from 'antd';

const Layout = styled.div`
  height: 112px;
  background: #dff4f0;
  position: relative;
  &:before {
    content: attr(data-content);
    position: absolute;
    top: 0;
    left: 11px;
    background: #7ed321;
    font-size: 12px;
    color: #fff;
    font-weight: 700;
    padding: 0 0.7em 0 0.5em;
    border-radius: 0 0 30% 0px / 0 0 90% 0;
  }
  & .ant-progress-bg {
    transition: none;
  }
`;

interface AudioPlayerProps extends React.Props<null> {
  src: string;
  fileType: string;
  type?: string;
}

interface AudioPlayerState {
  isPlaying: boolean;
  currentTime: number;
  duration: number;
}

function durationToString(duration: number) {
  return `${Math.floor(duration / 60)
    .toString()
    .padStart(2, '0')}:${Math.floor(duration % 60)
    .toString()
    .padStart(2, '0')}`;
}

export class AudioPlayer extends React.Component<AudioPlayerProps, AudioPlayerState> {
  public static Audios: any = {};
  private id: string;

  constructor(props: AudioPlayerProps) {
    super(props);
    this.state = {
      isPlaying: false,
      currentTime: 0,
      duration: 0,
    };
    this.id = Math.random()
      .toString(36)
      .substring(4);

    AudioPlayer.Audios[this.id] = this;
  }

  private audio = React.createRef<HTMLAudioElement>();

  public componentDidMount() {
    this.audio.current.addEventListener('loadeddata', this.onloaddata);
    this.audio.current.addEventListener('timeupdate', this.ontimeupdate);
    this.audio.current.addEventListener('ended', this.onended);
  }

  public componentWillUnmount() {
    this.audio.current.removeEventListener('loadeddata', this.onloaddata);
    this.audio.current.removeEventListener('timeupdate', this.ontimeupdate);
    this.audio.current.removeEventListener('ended', this.onended);
    delete AudioPlayer.Audios[this.id];
    this.audio.current.pause();
  }

  public onloaddata = () => {
    this.setState({
      duration: this.audio.current.duration,
    });
  };

  public ontimeupdate = () => {
    this.setState({
      currentTime: this.audio.current.currentTime,
    });
  };

  public onended = () => {
    this.setState({
      currentTime: 0,
      isPlaying: false,
    });
  };

  public togglePlay = () => {
    if (this.audio.current) {
      const audio = this.audio;

      if (this.state.isPlaying) {
        audio.current.pause();
      } else {
        const ids = Object.keys(AudioPlayer.Audios);
        for (const id of ids) {
          const otherAudio = AudioPlayer.Audios[id];
          if (otherAudio && otherAudio.id !== this.id) {
            otherAudio.setState({
              isPlaying: false,
            });
            if (otherAudio.audio.current) {
              otherAudio.audio.current.pause();
            }
          }
        }
        audio.current.play();
      }

      this.setState({
        isPlaying: !this.state.isPlaying,
      });
    }
  };

  public render() {
    const { currentTime, duration, isPlaying } = this.state;
    return (
      <Layout data-hoverable-media={true} data-content={this.props.fileType}>
        <audio src={this.props.src} ref={this.audio} preload={'metadata'} />
        <div
          style={{
            // width增加了判断 如果是详情则会渲染详情的UI
            width: this.props.type === 'detail' ? '584px' : '235px',
            height: '50px',
            marginLeft: '11px',
            marginRight: '11px',
            background: '#fff',
            borderRadius: '3px',
            position: 'relative',
            top: '38px',
          }}>
          <div
            style={{
              width: this.props.type === 'detail' ? '560px' : '222px',
              marginLeft: '9px',
              display: 'flex',
              justifyContent: 'space-between',
              paddingTop: '8px',
            }}>
            <Progress
              strokeColor={alo7Theme.primaryColor}
              type={'line'}
              strokeWidth={6}
              percent={Math.ceil((currentTime / duration) * 100)}
              showInfo={false}
              style={{
                width: this.props.type === 'detail' ? '520px' : '190px',
              }}
            />
            <Icon
              onClick={(e: any) => {
                e.stopPropagation();
                this.togglePlay();
              }}
              type={isPlaying ? 'pause' : 'caret-right'}
              style={{
                fontSize: '24px',
                color: alo7Theme.primaryColor,
                cursor: 'pointer',
              }}
            />
          </div>
          <div
            style={{
              fontSize: '13px',
              color: '#9B9B9B',
              marginLeft: '9px',
              display: 'flex',
              width: this.props.type === 'detail' ? '520px' : '190px',
              justifyContent: 'space-between',
              transform: 'translateY(-4px)',
            }}>
            <div>{durationToString(currentTime)}</div>
            <div>{durationToString(duration)}</div>
          </div>
        </div>
      </Layout>
    );
  }
}
